// extracted by mini-css-extract-plugin
export default {"signup-form":"Sign_signup-form__J2jaB"};